var _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPay = function SvgPay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 16"
  }, props), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "translate(-779 -37)",
    fill: "#292A2C",
    fillRule: "evenodd",
    fontFamily: "LucidaGrande-Bold, Lucida Grande",
    fontSize: 16,
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 778,
    y: 49
  }, "Pay"))));
};
export default SvgPay;